import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UserService } from "../../core/services/user/user.service";
import { IActionOdataResult } from "../models/interfaces/action-result.interface";
import { IClassroom } from "../models/interfaces/classroom.interface";
import { IParamObj, IParamQuery } from "../models/interfaces/param-query.interface";

@Injectable({
    providedIn: 'root'
})
export class ClassroomService {

    constructor(private http: HttpClient, private userService: UserService) { }
    /**
     * Returns an array of regions based paramQuery
     */
    public get(params?: IParamObj): Observable<Array<IClassroom>> {
        const paramQuery: IParamQuery = (params) ? { params: params } : null;
        return this.getClassrooms(paramQuery).pipe(map((result) => result.value as Array<IClassroom>));
    }

    private getClassrooms(paramQuery: IParamQuery): Observable<IActionOdataResult> {
        const httpParams = (paramQuery) ? paramQuery : {};
        return this.http.get<IActionOdataResult>(environment.apiBaseURL + 'odata/Classrooms', httpParams);
    }
}

